import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HandicapIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M9.944 22C6.098 22 3 19.03 3 15.341c0-1.946.961-3.893 2.564-5.122.427-.307 1.175-.307 1.496.103.427.41.32 1.126-.107 1.434-1.175.922-1.816 2.253-1.816 3.585 0 2.561 2.136 4.61 4.807 4.61 1.602 0 3.205-.82 4.06-2.151.32-.512.961-.615 1.495-.308.534.308.641.922.32 1.435C14.539 20.873 12.295 22 9.945 22zM13 10H9c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1z"
                        }),
                        _jsx("path", {
                            d: "M21.917 16.6c-.216-.5-.865-.7-1.405-.5l-2.054.8-2.162-4.5c-.324-.6-.973-1-1.621-1H9.919l-.54-5c1.296 0 2.27-1 2.27-2.2 0-1.2-.974-2.2-2.27-2.2-.65 0-1.298.3-1.73.7C7.216 3.1 7 3.7 7 4.4l.757 7.5c.108.9.864 1.5 1.837 1.5h4.865L16.62 18c.324.6.972 1 1.62 1 .217 0 .433 0 .758-.1l2.378-.9c.54-.3.756-.9.54-1.4z"
                        })
                    ]
                })
            })
        ]
    });
};
HandicapIcon.isCarinaIcon = true;
export default HandicapIcon;
